export default {
  '渠道调拨': '渠道調撥',
  '单据编号': '單據編號',
  '手工单号': '手工單號',
  '发货单位': '發貨單位',
  '收货单位': '收貨單位',
  '单据日期': '單據日期',
  '打印人': '打印人',
  '打印时间': '打印時間',
  '备注': '備註',
  '货号': '貨號',
  '品名': '品名',
  '颜色编号': '顏色編號',
  '颜色': '顏色',
  '内长': '內長',
  '数量': '數量',
  '吊牌价': '吊牌價',
  '吊牌额': '吊牌額',
  '发出方签': '發出方簽',
  '日期': '日期',
  '接收方签': '接收方簽',
  '店长复核': '店長復核',
  '竖排': '竖排',
  '横排': '横排',
  '店铺编码': '店鋪編碼',
  '店铺名称': '店鋪名稱',
  '日结日期': '日結日期',
  '销售单情况': '銷售單情況',
  '销售金额': '銷售金額',
  '计收入': '計收入',
  '销售数量': '銷售數量',
  '销售单数': '銷售單數',
  '销售单退货情况': '銷售單退貨情況',
  '退货金额': '退貨金額',
  '退货数量': '退貨數量',
  '退货单数': '退貨單數',
  '销售单付款情况': '銷售單付款情況',
  '储值卡充值情况': '儲值卡充值情況',
  '实收金额': '實收金額',
  '赠送金额': '贈送金額',
  '充值笔数': '充值筆數',
  '所有付款方式汇总': '所有付款方式匯總',
  '班次': '班次',
  '生意额': '生意額',
  '期初': '期初',
  '销售现金': '銷售現金',
  '银行存款': '銀行存款',
  '现金调整': '現金調整',
  '期末': '期末',
  '销售金额（计收入）': '銷售金額（計收入）',
  '服务费付款情况': '服務費付款情況',
  '服务费金额': '服務費金額',
  '服务费数量': '服務費數量',
  '服务费单数': '服務費單數',
  '服务费退款情况': '服務費退款情況',
  '服务费退款': '服務費退款',
  '退款金额': '退款金額',
  '退款数量': '退款數量',
  '退款单数': '退款單數',
  '充值金额': '充值金額',
  '笔': '筆',
  '合计': '合計',
  '渠道': '渠道',
  '收银': '收銀',
  '销售日期': '銷售日期',
  '付款方式': '付款方式',
  '金额': '金額',
  '充值单据': '充值單據',
  '颜色/内长': '顏色/內長',
  '尺码': '尺碼',
  '货品': '貨品',
  '会员价': '會員價',
  '折扣': '折扣',
  '折后价': '折後價',
  '税额': '稅額',
  '会员': '會員',
  '折扣/折后价': '折扣/折後價折后价',
  '税额/金额': '稅額/金額金额',
  '获得积分': '获得积分',
  '储值余额': '储值余额',
  '积分余额': '积分余额',
  '充值时间': '充值时间',
  '服务费': '服務費'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/receipt.js